import array from '@mailobj-browser/front/js/utils/array.js'
import contract from '@mailobj-browser/front/js/contracts/contract.js'
import ccBcc from './ccBcc.js'

export default contract({
  ccBcc: array([
    ccBcc
  ]),
})